<script>
import gaFilterComponentMixin from '@mixins/gaFilterComponentMixin';
import gaFilterAutocompleteMixin from '@mixins/gaFilterAutocompleteMixin';
import GaBaseExpandedFilter from '@components/v2/filter/sidebarFilters/parts/GaBaseExpandedFilter.vue';
import GaBaseFoldedFilter from '@components/v2/filter/sidebarFilters/parts/GaBaseFoldedFilter.vue';
import Checkbox from 'primevue/checkbox';
import permissionsMixinComputed from '@mixins/permissionsMixinComputed';
import AkInputText from '@components/v2/input/AkInputText.vue';
import housekeeperService from '@services/housekeeperService';
import housekeeperAutocompleteMixin from '@mixins/autocomplete/housekeeperAutocompleteMixin';
import AkShimmer from '@components/v2/general/AkShimmer.vue';
import GaFilterBaseAutocomplete from '@components/v2/filter/sidebarFilters/parts/GaFilterBaseAutocomplete.vue';

export default {
  name: 'GaFilterHousekeepers',
  components: {GaFilterBaseAutocomplete, AkShimmer, AkInputText, Checkbox, GaBaseFoldedFilter, GaBaseExpandedFilter},
  mixins: [gaFilterComponentMixin, gaFilterAutocompleteMixin, housekeeperAutocompleteMixin, permissionsMixinComputed],
  data() {
    return {
      searchFilter: {
        contactName: null,
      },
      suggestions: [],
      suggestionsLoading: false,
    };
  },
  methods: {
    init() {
      if (this.isOwner) {
        return this.autocompleteHousekeeper({}).then((data) => {
          this.options = data;
          this.optionsLoaded = true;
        });
      }
    },
    removeOption(option) {
      if (this.isOwner) return;
      this.options = this.options.filter((o) => o.id !== option.id);
      this.$refs.autocomplete.removeSuggestion(option);
    },
  },
  watch: {
    isExpanded(newVal) {
      if (newVal) {
        this.searchFilter.contactName = null;
        if (!this.isOwner) {
          this.options = [];
          this.currentFilter.value.forEach((value, index) => {
            this.options.push({id: value, display: this.currentValue.labels[index]});
          });

          this.$nextTick(() => {
            this.$refs.autocomplete.resetSuggestions();
            this.$refs.autocomplete.initSelectedSuggestions(this.options);
          });
        }
      }
    },
  },
};
</script>

<template>
  <template v-if="isVisible">
    <GaBaseFoldedFilter
      v-if="!isExpanded"
      title="Concierge"
      @expand="onClick"
      :icon="hasIcon ? 'ga-hand_key' : null"
      :subtitle="subtitle"
      :nb-selected="nbSelected" />
    <GaBaseExpandedFilter
      v-else
      title="Concierge"
      :nb-selected="nbSelected"
      :can-go-back="canGoBack"
      @apply="apply"
      @reset="reset"
      @back="back">
      <GaFilterBaseAutocomplete
        v-if="!this.isOwner"
        ref="autocomplete"
        :filter="searchFilter"
        filter-property="contactName"
        :search-method="autocompleteHousekeeper"
        @option-select="checkOption"
        placeholder="Rechercher un concierge" />

      <div class="flex flex-col gap-1 px-3.5 py-3">
        <div v-for="option in options" :key="option.id" class="py-1.5 px-3 w-full">
          <label class="gap-3 flex px-2 py-1 items-center cursor-pointer">
            <checkbox
              v-model="currentFilter.value"
              @update:model-value="removeOption(option)"
              :value="option.id"
              class="[&_.p-checkbox-box]:!border-grey [&_.p-checkbox-box]:border [&_.p-checkbox-box]:rounded-6"
              :class="{
                '[&_.p-checkbox-box]:!bg-primary [&_.p-checkbox-box]:border-0': currentFilter.value.includes(option.id),
              }" />
            <span class="font-medium text-grey-900 select-none">
              {{ option.display }}
            </span>
          </label>
        </div>
      </div>
    </GaBaseExpandedFilter>
  </template>
</template>

<style scoped></style>
